import axios from 'axios'
import { getToken, removeToken } from '@/utils'
import router from '../router'
import store from '@/store'
import { isMobile } from '@/utils/validate'
import qs from 'qs'

// 创建axios实例
const service = axios.create({
  baseURL: `//webapi.693975.com/web/index.php`, // api 的 base_url
  timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 格式化数据
    const mobileInfo = window.mobileInfo
    const gToken = store.getters.appid
    const imei = store.getters.idfa
    const agentId = router.history.current.query.agent_id || 100000
    const siteId = router.history.current.query.site_id || 100000
    const os = mobileInfo.os
    const model = mobileInfo.model
    const systemversion = mobileInfo.version
    // 处理post和get请求字段名不一样的情况
    if (config.method === 'post') {
      config.data = Object.assign({}, config.data, { g_token: gToken, imei, agent_id: agentId, site_id: siteId, os, model, systemversion })
      if (isMobile()) {
        config.data = Object.assign({}, config.data, { os, model, systemversion })
      }
      if (getToken() && getToken() !== 'undefined') {
        config.data.session_id = getToken()
      } else {
        config.data.session_id = store.getters.init.session_id || null
      }
    }
    if (config.method === 'get') {
      config.params = Object.assign({}, config.params, { g_token: gToken, imei, agent_id: agentId, site_id: siteId, os, model, systemversion })
      if (isMobile()) {
        config.params = Object.assign({}, config.params, { os, model, systemversion })
      } else {
        config.params = Object.assign({}, config.params, { os: 'pc' })
      }
      if (getToken() && getToken() !== 'undefined') {
        config.params.session_id = getToken()
      } else {
        config.params.session_id = store.getters.init.session_id || null
      }
    }
    config.data = qs.stringify(config.data)
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.data.error_code === 1006) {
      removeToken()
      store.commit('SET_TOKEN', '')
      window.location.reload()
      return Promise.reject(response.data)
    } else {
      return response
    }
  }
)

export default service
